import { Link } from "react-router-dom";

import { useTranslation } from 'react-i18next';
export default function Breadcrumbs({ items }) {
  const { t } = useTranslation();
  return (
    <nav aria-label={t('breadcrumbs.breadcrumb')} className="max-w-7xl mx-auto px-6 lg:px-12 pt-6">
      <ol className="flex items-center gap-2 text-xs font-mono text-zinc-500">
        {items.map((item, idx) => (
          <li key={idx} className="flex items-center gap-2">
            {idx > 0 && <span className="text-zinc-700" aria-hidden="true">/</span>}
            {item.path ? (
              <Link
                to={item.path}
                className="hover:text-amber-500 transition-colors"
              >
                {item.label}
              </Link>
            ) : (
              <span className={idx === items.length - 1 ? "text-zinc-300" : ""}>
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
